
import { useEffect, useState } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import Servicos from "./pages/Servicos";
import Sobre from "./pages/Sobre";
import Contato from "./pages/Contato";
import NotFound from "./pages/NotFound";
import Cidades from "./pages/Cidades";
import EstadoPage from "./pages/EstadoPage";
import CidadePage from "./pages/CidadePage";
import { initializeData } from "./data/estados-cidades";
import SitemapGenerator from "./components/SitemapGenerator";
import SitemapXml from "./components/SitemapXml";

const queryClient = new QueryClient();

// Check if we're running on server or client
const isServer = typeof window === 'undefined';

// Componente para carregar dados pré-renderizados da cidade
const PreloadedCityData = () => {
  useEffect(() => {
    // Verificar se estamos em uma página de cidade com dados pré-carregados
    const cityDataScript = document.getElementById('city-data');
    if (cityDataScript) {
      try {
        // Armazenar os dados no localStorage para uso pelo CidadePage
        const cityData = JSON.parse(cityDataScript.textContent || '{}');
        if (cityData.cidade) {
          localStorage.setItem('preloaded-city-data', JSON.stringify(cityData));
          console.log('Dados da cidade pré-carregados:', cityData);
        }
      } catch (error) {
        console.error('Erro ao analisar dados pré-carregados da cidade:', error);
      }
    }

    return () => {
      // Remover dados pré-carregados ao desmontar o componente
      // localStorage.removeItem('preloaded-city-data');
    };
  }, []);

  return null;
};

const App = () => {
  // Inicializar os dados quando o aplicativo é carregado
  useEffect(() => {
    if (!isServer) {
      initializeData().catch(error => 
        console.error("Erro ao inicializar dados na aplicação:", error)
      );
    }
  }, []);

  // Verificar se estamos na rota /sitemap.xml para renderizar diferentemente
  const isSitemapRoute = !isServer && window.location.pathname === '/sitemap.xml';
  
  // Se for a rota do sitemap, retornar apenas o componente SitemapXml
  // sem os outros componentes da UI
  if (isSitemapRoute) {
    return <SitemapXml />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <PreloadedCityData />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/servicos" element={<Servicos />} />
              <Route path="/sobre" element={<Sobre />} />
              <Route path="/contato" element={<Contato />} />
              
              {/* Rotas para cidades */}
              <Route path="/cidades" element={<Cidades />} />
              <Route path="/estado/:estado" element={<EstadoPage />} />
              <Route path="/cidade/local/:cidade" element={<CidadePage />} />
              
              {/* Rota para o gerador de sitemap */}
              <Route path="/admin/sitemap-generator" element={<SitemapGenerator />} />
              
              {/* Rota 404 para qualquer URL não encontrada */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </HelmetProvider>
    </QueryClientProvider>
  );
};

export default App;
